import Animate from './partials/animate';
import Quiz from './partials/quiz';
import PartnerListSlider from "./partials/partner-list-slider";
import PartnerSlider from "./partials/partner-slider";
import VideoSlider from "./partials/video-slider";
import VideoWidthImage from "./partials/video-width-image";
import DesktopMenu from "./partials/desktop-menu";
import MobileMenu from "./partials/mobile-menu";
import GallerySlider from "./partials/gallery-slider";
import SocialList from "./partials/social-list";
import SocialSlider from "./partials/social-slider";
import Link from "./partials/link";

window.initDom = ($wrapper) => {
    $wrapper.querySelectorAll('[data-animate]').forEach($el => (new Animate($el)));
    $wrapper.querySelectorAll('[data-quiz]').forEach($el => (new Quiz($el)));
    $wrapper.querySelectorAll('[data-block-type="partner-list"]').forEach($el => (new PartnerListSlider($el)));
    $wrapper.querySelectorAll('[data-block-type="partner-slider"]').forEach($el => (new PartnerSlider($el)));
    $wrapper.querySelectorAll('[data-gallery-slider]').forEach($el => (new GallerySlider($el)));
    $wrapper.querySelectorAll('[data-video-slider]').forEach($el => (new VideoSlider($el)));
    $wrapper.querySelectorAll('[data-video-width-image]').forEach($el => (new VideoWidthImage($el)));
    $wrapper.querySelectorAll('[data-desktop-menu]').forEach($el => (new DesktopMenu($el)));
    $wrapper.querySelectorAll('[data-mobile-menu]').forEach($el => (new MobileMenu($el)));
    $wrapper.querySelectorAll('[data-block-type="social-list-block-maya-international"]').forEach($el => (new SocialList($el)));
    $wrapper.querySelectorAll('[data-block-type="social-slider"]').forEach($el => (new SocialSlider($el)));
    $wrapper.querySelectorAll('[data-href]').forEach($el => (new Link($el)));
}

(function() {
    window.initDom(document);
})();